import React from 'react';

const VALUES = [
    { icon: '🌿', title: 'Holistic Care', desc: 'Blending ancient Ayurvedic wisdom with modern AI for truly comprehensive health guidance.' },
    { icon: '🔬', title: 'Science-Backed', desc: 'Every recommendation is grounded in validated clinical research and Ayurvedic texts.' },
    { icon: '🔒', title: 'Privacy First', desc: 'Bank-grade encryption protects your sensitive health data at every step.' },
    { icon: '🤝', title: 'Accessible to All', desc: 'Breaking barriers to quality healthcare for patients and practitioners alike.' },
];



export default function About() {
    return (
        <section className="na-about" id="about">
            <div className="na-section-container">

                {/* Section header */}
                <div className="na-section-header">
                    <span className="na-badge">Our Story</span>
                    <h2 className="na-section-title">
                        Bridging <span className="na-gradient-text">Ancient Wisdom</span> &amp; Modern Medicine
                    </h2>
                    <p className="na-section-sub">
                        VaidyaMed-X was born from a belief — that everyone deserves intelligent, compassionate healthcare.
                        We combine the timeless principles of Ayurveda with cutting-edge AI to redefine what health support looks like.
                    </p>
                </div>

                {/* Values grid */}
                <div className="na-values-grid">
                    {VALUES.map(v => (
                        <div className="na-value-card" key={v.title}>
                            <div className="na-value-icon">{v.icon}</div>
                            <h3 className="na-value-title">{v.title}</h3>
                            <p className="na-value-desc">{v.desc}</p>
                        </div>
                    ))}
                </div>

                {/* Mission strip */}
                <div className="na-mission-strip">
                    <div className="na-mission-left">
                        <h3>Our Mission</h3>
                        <p>
                            To democratize access to holistic health intelligence — serving patients with empathy
                            and empowering doctors with precision AI tools, anchored in the values of Ayurveda.
                        </p>
                    </div>
                    <div className="na-mission-stats">
                        {[['50K+', 'Consultations'], ['200+', 'Expert Doctors'], ['98%', 'Satisfaction'], ['15+', 'Specializations']].map(([n, l]) => (
                            <div className="na-mission-stat" key={l}>
                                <span className="na-mission-num">{n}</span>
                                <span className="na-mission-lbl">{l}</span>
                            </div>
                        ))}
                    </div>
                </div>

                {/* Team */}
                <div className="na-section-header" style={{ marginTop: '60px' }}>
                    <span className="na-badge">Meet the Team</span>
                    <h2 className="na-section-title">The Minds Behind <span className="na-gradient-text">VaidyaMed-X</span></h2>
                </div>
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: '40px', alignItems: 'center', justifyContent: 'center', marginTop: '40px' }}>
                    {/* Left: Founder Card */}
                    <div className="na-team-card" style={{ '--card-bg': '#e8f5ee', flex: '0 1 280px', margin: '0' }}>
                        <div className="na-team-avatar" style={{ background: 'linear-gradient(135deg, #2d6a4f 0%, #52b788 100%)' }}>
                            <img
                                src="/Govind.jpeg"
                                alt="Govind Sharma"
                                className="na-team-photo"
                                onError={e => { e.currentTarget.style.display = 'none'; }}
                            />
                        </div>
                        <h4 className="na-team-name">Govind Sharma</h4>
                        <p className="na-team-role">Founder & CEO</p>
                    </div>

                    {/* Right: Dynamic Company Details */}
                    <div style={{ flex: '1 1 400px', padding: '20px', textAlign: 'left' }}>
                        <style>
                            {`
                                @keyframes runningText {
                                    0% { transform: translateX(100%); }
                                    100% { transform: translateX(-100%); }
                                }
                                .marquee-container {
                                    overflow: hidden;
                                    white-space: nowrap;
                                    width: 100%;
                                    box-sizing: border-box;
                                    padding-bottom: 10px;
                                }
                                .marquee-text {
                                    display: inline-block;
                                    animation: runningText 12s linear infinite;
                                }
                            `}
                        </style>
                        <div className="marquee-container">
                            <h3 className="marquee-text" style={{ 
                                fontFamily: 'Playfair Display, serif', 
                                fontSize: '2.5rem', 
                                background: 'linear-gradient(135deg, #1a2e1a 0%, #2d6a4f 100%)',
                                WebkitBackgroundClip: 'text',
                                WebkitTextFillColor: 'transparent',
                                lineHeight: 1.3,
                                marginBottom: '18px',
                                fontWeight: 700
                            }}>
                                Mira Future Tech Vision Private Limited
                            </h3>
                        </div>
                        <p style={{ color: '#475569', fontSize: '1.05rem', lineHeight: 1.7, fontWeight: 400 }}>
                            The driving force and parent organization behind VaidyaMed-X. We are committed to revolutionizing healthcare by seamlessly blending ancient Ayurvedic wisdom with futuristic Artificial Intelligence technologies.
                        </p>
                    </div>
                </div>
            </div>
        </section>
    );
}
